import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ProductCollectionProvider extends HttpRequest {
  createProductCollection (payload) {
    this.setHeader(getAuthToken())
    return this.post('/product/collections', payload)
  }

  deleteProductCollection (queryId) {
    this.setHeader(getAuthToken())
    return this.delete('/product/collections', queryId)
  }

  updateProductCollection (param, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/product/collections/${param}`, payload)
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/product/collections/${id}`)
  }

  getAll (query) {
    this.setHeader(getAuthToken())
    return this.get('/product/collections', query)
  }

  getAllStore (query) {
    this.setHeader(getAuthToken())
    return this.get('/product/collections/all', query)
  }

  updateCollectionSalesDateById (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/product/collections/sale-date', payload)
  }

  getCollectionWithPrototype (payload) {
    this.setHeader(getAuthToken())
    return this.get('/product/collections/sale-date/by-month', payload)
  }

  getCollectionSaleDateCalendar (query) {
    this.setHeader(getAuthToken())
    return this.get('/product/collections/calendar/sale-date', query)
  }
}

export default ProductCollectionProvider
